export default [{
  text: 'Created at',
  value: 'created_at',
  width: '110px'
}, {
  text: 'Invoice ID',
  value: 'invoice_number',
}, {
  text: 'Contract / Advertiser',
  value: 'title',
  apiSort: 'cost_center',
}, {
  text: 'Business',
  value: 'business.name',
  apiSort: 'businesses.name',
}, {
  text: 'Legal business name',
  value: 'legal_business_name',
}, {
  text: 'Total amount',
  value: 'total_amount',
  isCurrency: true,
}, {
  text: 'Actions',
  value: 'actions',
  action: 'pdf',
  icon: 'picture_as_pdf',
  isAction: true,
  sortable: false,
}];
